import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

interface EventLocationDescriptionFieldsProps {
  location: string;
  description: string;
  onLocationChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

export const EventLocationDescriptionFields: React.FC<EventLocationDescriptionFieldsProps> = ({
  location,
  description,
  onLocationChange,
  onDescriptionChange,
}) => {
  return (
    <>
      <div>
        <Label htmlFor="location">Location</Label>
        <Input
          id="location"
          value={location}
          onChange={(e) => onLocationChange(e.target.value)}
          className="bg-gray-900 border-gray-700 text-white"
          placeholder="e.g., Main Field, Stadium A"
        />
      </div>

      <div>
        <Label htmlFor="description">Description (Optional)</Label>
        <Textarea
          id="description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          className="bg-gray-900 border-gray-700 text-white"
          rows={3}
        />
      </div>
    </>
  );
};